import type { BasketUpsellProduct as BasketUpsellProductView } from '@features/scrollable-basket'
import type { BasketUpsellProduct, BasketUpsellResponse } from '@library/api-menu-experience'

type BuildBasketUpsellInput = {
  shouldShowBasketUpsells: boolean
  upsellResponse: BasketUpsellResponse | null
}

const getVisibleCarouselProducts = (upsellResponse: BasketUpsellResponse): BasketUpsellProduct[] =>
  upsellResponse.carousel?.productIds
    .map((productId) => upsellResponse.products[productId])
    .filter((product): product is BasketUpsellProduct => Boolean(product) && product.stock > 0) ??
  []

// TODO(NP-8304): wire these controls to real basket product mutations.
const noopProductMutation = () => {}

const toBasketUpsellProduct = (product: BasketUpsellProduct): BasketUpsellProductView => ({
  id: product.id,
  title: product.title,
  descriptionHTML: product.descriptionHTML,
  attributesHTML: product.attributesHTML,
  listPrice: product.listPrice,
  stock: product.stock,
  ageRestricted: product.ageRestricted,
  boxLimit: product.boxLimit,
  images: product.images,
  displayTags: product.displayTags,
  isVatable: product.isVatable,
  // TODO(NP-8304): enable product controls once add/remove behaviour is in scope.
  isAvailable: false,
  limitReached: false,
  onAdd: noopProductMutation,
  onRemove: noopProductMutation,
  outOfStock: product.stock <= 0,
  qty: 0,
})

export const buildBasketUpsellViewModel = ({
  shouldShowBasketUpsells,
  upsellResponse,
}: BuildBasketUpsellInput) => {
  if (!shouldShowBasketUpsells || !upsellResponse?.carousel) return undefined

  return {
    carousel: {
      tag: upsellResponse.carousel.tag,
      title: upsellResponse.carousel.title,
      subtitle: upsellResponse.carousel.subtitle,
    },
    products: getVisibleCarouselProducts(upsellResponse).map(toBasketUpsellProduct),
  }
}
